import * as CRMObjectTypes from 'automation-ui-references/object-types/CRMObjectTypes';
import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import getIn from 'immutable-less/transmute/getIn';
const propertyLabelOverrideLangKey = {
  [CRMObjectTypes.DEAL_ID]: {
    dealstage: 'automation-ui-references.propertyLabelOverride.0-3.dealstage'
  },
  [CRMObjectTypes.TICKET_ID]: {
    hs_pipeline_stage: 'automation-ui-references.propertyLabelOverride.0-5.hs_pipeline_stage'
  },
  [CRMObjectTypes.LEAD_ID]: {
    hs_pipeline_stage: 'automation-ui-references.propertyLabelOverride.0-136.hs_pipeline_stage'
  }
};
export const getObjectTypePropertyLabel = (name, label, objectTypeId) => {
  const labelLangKey =
  // "constructor" is a reserved JS Object property, but may be a valid
  // property name.
  name !== 'constructor' && getIn([objectTypeId, name], propertyLabelOverrideLangKey);
  if (labelLangKey && isValidI18nKey(labelLangKey)) {
    return I18n.text(labelLangKey);
  }
  // properties are in english by default
  return label;
};